import { inject, observer } from "mobx-react";
import React, { Component, Fragment } from "react";
import AnimateHeight from "react-animate-height";

import { salt } from "../../@helpers";
import Close from "../icons/Close";
import Minus from "../icons/Minus";
import Plus from "../icons/Plus";
import Loading from "../Loading";
import Notice from "../Notice";
import PopUp from "../PopUp";
import Toggle from "../Toggle";
import Legend from "./Legend";
import "./legend.scss";
import "./style.scss";
import TableRow from "./TableRow";
import TargetHeight from "./TargetHeight";
import Tooltip from "./Tooltip";
import { languageContent } from "../../@helpers";

@inject("GrowthCalculatorStore")
@observer
class GrowthCalculator extends Component {
  chartAnchor = "";
  enableTargetHeightCalculation = false;
  componentDidMount() {
    const {
      GrowthCalculatorStore: { setAccordionHeight }
    } = this.props;
    setAccordionHeight();
    //updateImage('M0');
  }

  render() {
    const {
      GrowthCalculatorStore: {
        loadingData,
        accordionHeight,
        dataSet,
        image,
        calculatedAge,
        targetHeight,
        targetHeightError,
        sessionData,
        showHeight,
        iframeXML,
        isMetric,
        showError,
        errorMessage,
        showAbnormalWarning,
        belowHeight,
        aboveHeight,
        disabledPDF,
        clearAbnormalWarning,
        handleChangeDataSet,
        handleReset,
        handleSaveData,
        handleDownloadPDF,
        handleSubmit,
        toggleAccordion,
        handleToggleIsMetric,
        updateSessionData,
        calculateCurrentAge,
        handleSwitchGraph,
        addNewRow,
        deleteRow,
        getUnit,
        calculateTargetHeight,
        triggerUpload,
        handleUpload,
        calculatorEndpoint,
        dateOfBirthError,
        isCalculateTargetHeightClick,
        disableCalculateTargetHeightCheck
      }
    } = this.props;

    const content = languageContent();
    const { component } = content;
    const {
      datasets,
      form: {
        chooseDataset,
        basicInformation,
        fields,
        childsMeasurements,
        buttons,
        abnormalWarning,
        childsTargetHeight
      },
      tooltip
    } = component.GrowthCalculator;

    return (
      <Fragment>
        <div className="page_hero">
          <div className="content">
            <div className="growth_calculator_container">
              <div className="growth_calculator_section-first">
                <form
                  name="formLoad"
                  id="formLoad"
                  ref="formLoad"
                  target="iframeLoad"
                  action={`${calculatorEndpoint}/${dataSet}/webcharts.com/child.xml`}
                  method="post"
                  encType="multipart/form-data"
                >
                  <input
                    className="growth_calculator_uploadInput"
                    id="loadFile"
                    name="fileLoad"
                    type="file"
                    ref="fileUploader"
                    onChange={e => handleUpload(e.target.files, this.refs)}
                  />
                  <button
                    className="button button-full"
                    type="button"
                    onClick={() => triggerUpload(this.refs.fileUploader)}
                  >
                    {buttons.uploadPreviousData}
                  </button>
                </form>

                <form
                  className="growth_calculator"
                  onSubmit={e => {
                    handleSubmit(e);
                    // this.chartAnchor.scrollIntoView();
                    function getOffset(el) {
                      const rect = el.getBoundingClientRect();
                      return {
                        left: rect.left + window.scrollX,
                        top: rect.top + window.scrollY
                      };
                    }
                    var topOfElement = getOffset(document.querySelector('.growth_chart_container img')).top - 150;
                    console.log(topOfElement)
                    window.scroll({ top: topOfElement, behavior: "smooth" });
                  }}
                  onReset={handleReset}
                >
                  <fieldset>
                    <div className="label_title">
                      <div className="flex-mobile">
                        <label>{chooseDataset.label}</label>{" "}
                        {(dataSet === "who" ||
                        dataSet === "uk" ||
                        dataSet === "us") && (
                          <PopUp>
                            {(dataSet === "who" || dataSet === "es-who") && (
                              <div className="popup_content">
                                <p>{chooseDataset.pTagFirst} </p>
                                <p>{chooseDataset.pTagSecond}</p>
                              </div>
                            )}
                            {dataSet === "uk" && (
                              <div className="popup_content">
                                <p>{chooseDataset.dataSetUK}</p>
                              </div>
                            )}
                            {dataSet === "us" && (
                              <div className="popup_content">
                                <p>{chooseDataset.dataSetUS}</p>
                              </div>
                            )}
                          </PopUp>
                        )}
                      </div>
                      <span className="fancy-select">
                        <select
                          name="dataset"
                          id="dataset"
                          value={dataSet}
                          onChange={handleChangeDataSet}
                        >
                          {datasets.map(dataset => (
                            <option key={salt()} value={dataset.value}>
                              {dataset.text}
                            </option>
                          ))}
                        </select>
                      </span>
                    </div>

                    <Toggle
                      isActive={isMetric}
                      handleToggle={handleToggleIsMetric}
                      left={chooseDataset.metricSystem.metric}
                      right={chooseDataset.metricSystem.imperial}
                    />
                  </fieldset>
                  <fieldset>
                    <legend>
                      {basicInformation.legend}{" "}
                      <button
                        aria-label={`Toggle basic information accordion. ${
                          accordionHeight === 0 ? "Closed" : "Open"
                        }`}
                        className="button button-icon"
                        type="button"
                        data-active={accordionHeight === 0 ? false : true}
                        onClick={toggleAccordion}
                      >
                        {accordionHeight === 0 && <Plus />}
                        {accordionHeight !== 0 && <Minus />}
                      </button>
                    </legend>
                    <AnimateHeight duration={300} height={accordionHeight}>
                      <fieldset>
                        <div className="form-grid">
                          <label>
                            <p className="label_title">{fields.dob}</p>
                            <input
                              aria-label="Date of birth"
                              required
                              placeholder="dd/mm/yyyy"
                              id="BirthDate"
                              ref="BirthDate"
                              type="date"
                              onChange={e => {
                                updateSessionData(e);
                                calculateCurrentAge(e);
                              }}
                            />
                            {dateOfBirthError && (
                              <p className="label_text birth_date_error">
                                {dateOfBirthError}
                              </p>
                            )}
                          </label>
                          <label>
                            <p className="label_title">{fields.gender}</p>
                            <div className="fancy-select">
                              <select
                                aria-label="Gender"
                                required
                                id="Sex"
                                ref="Sex"
                                onChange={updateSessionData}
                              >
                                <option value="F">
                                  {fields.genderSelect.girl}
                                </option>
                                <option value="M">
                                  {fields.genderSelect.boy}
                                </option>
                              </select>
                            </div>
                          </label>
                        </div>
                      </fieldset>
                      {calculatedAge && (
                        <p className="label_text">
                          {fields.age}: {calculatedAge.years} {fields.years},{" "}
                          {calculatedAge.months} {fields.months}
                        </p>
                      )}
                      <fieldset>
                        <legend className="flex-mobile first-legend">
                          <span>{childsMeasurements.firstLegend}</span>{" "}
                          <PopUp>
                            <div className="popup_content">
                              <p className="popup_title-large">
                                {childsMeasurements.popUp1.pTagFirst}
                              </p>
                              <p>{childsMeasurements.popUp1.pTagSecond}</p>
                              <p>
                                {childsMeasurements.popUp1.pTagThird}
                                <sup>1</sup>{" "}
                              </p>
                              <p>{childsMeasurements.popUp1.pTagFourth}</p>
                              <p>
                                <small>
                                  <sup>1</sup>
                                  {childsMeasurements.popUp1.pTagFifth}
                                </small>
                              </p>
                            </div>
                          </PopUp>
                        </legend>
                        <div className="form-grid">
                          <label>
                            <p className="label_title">
                              {fields.fathersHeight}
                            </p>
                            <div>
                              <input
                                required={isCalculateTargetHeightClick}
                                type="number"
                                min="0"
                                step="0.01"
                                id="FatherHeight"
                                ref="FatherHeight"
                                value={
                                  sessionData.FatherHeight
                                    ? sessionData.FatherHeight[getUnit()]
                                    : ""
                                }
                                onChange={updateSessionData}
                              />
                              <span className="suffix">
                                ({isMetric ? "cm" : "in"})
                              </span>
                            </div>
                          </label>
                          <label>
                            <p className="label_title">
                              {fields.mothersHeight}
                            </p>
                            <div>
                              <input
                                required={isCalculateTargetHeightClick}
                                type="number"
                                min="0"
                                step="0.01"
                                id="MotherHeight"
                                ref="MotherHeight"
                                value={
                                  sessionData.MotherHeight
                                    ? sessionData.MotherHeight[getUnit()]
                                    : ""
                                }
                                onChange={updateSessionData}
                              />
                              <span className="suffix">
                                ({isMetric ? "cm" : "in"})
                              </span>
                            </div>
                          </label>
                        </div>
                      </fieldset>
                      {targetHeight && (
                        <TargetHeight
                          targetHeight={targetHeight}
                          isMetric={isMetric}
                          targetText={childsTargetHeight}
                        />
                      )}
                      {targetHeightError && (
                        <p className="gc-error-text label_text">
                          {targetHeightError}
                        </p>
                      )}
                      <p className="buttons_container">
                        <button
                          id="calculate-target-height"
                          className="button"
                          type="button"
                          onClick={calculateTargetHeight}
                        >
                          {buttons.calculateTargetHeight}
                        </button>
                      </p>
                    </AnimateHeight>
                  </fieldset>
                  <fieldset>
                    <div className="flex-mobile">
                      <div className="labels">
                        <legend>{childsMeasurements.secondLegend}</legend>
                        <div className="label_text">
                          <span>
                            {childsMeasurements.popUp2.popupTitleLarge}
                          </span>
                        </div>
                      </div>{" "}
                      <div className="lower-btn">
                        <PopUp>
                          <div className="popup_image">
                            <img
                              src="/static/measure-your-child.jpg"
                              alt="A diagram demonstrating how to measure a child"
                            />
                          </div>
                          <div className="popup_content">
                            <p className="popup_title-large">
                              {childsMeasurements.popUp2.popupTitleLarge}
                              <sup>2</sup>
                            </p>
                            <p>{childsMeasurements.popUp2.pTagFirst}</p>
                            <p className="popup_title">
                              {childsMeasurements.popUp2.popupTitle}
                            </p>
                            <p>{childsMeasurements.popUp2.pTagSecond}</p>
                            <p>{childsMeasurements.popUp2.pTagThird}</p>
                            <ol>
                              {childsMeasurements.popUp2.olTag &&
                                childsMeasurements.popUp2.olTag.map(
                                  (item, index) => (
                                    <li key={`olTag__item${index}`}>{item}</li>
                                  )
                                )}
                            </ol>
                            <p>
                              <small>
                                <strong>
                                  {childsMeasurements.popUp2.pTagFourth}
                                </strong>
                              </small>
                            </p>
                            <p>
                              <small
                                style={{
                                  wordBreak: "break-word",
                                  wordWrap: "break-word",
                                  width: "100%"
                                }}
                              >
                                <sup>2</sup>
                                {childsMeasurements.popUp2.pTagFifth}{" "}
                              </small>
                            </p>
                          </div>
                        </PopUp>
                      </div>
                    </div>
                    <div className="data-table_container">
                      {sessionData.childTableData &&
                        sessionData.childTableData.map((childDatum, index) => (
                          <TableRow
                            key={`data_row-${childDatum.Id}`}
                            id={childDatum.Id}
                            index={index}
                            data={childDatum}
                            sessionData={sessionData}
                            isMetric={isMetric}
                            getUnit={getUnit}
                            deleteRow={id => deleteRow(id)}
                            updateSessionData={updateSessionData}
                            fieldNames={fields}
                          />
                        ))}
                    </div>
                  </fieldset>
                  <fieldset>
                    <div className="buttons_container">
                      <button
                        id="calculator-submit"
                        className="button button-hero"
                        type="submit"
                        onClick={disableCalculateTargetHeightCheck}
                      >
                        {buttons.submit}
                      </button>
                      <Tooltip content={tooltip.addData}>
                        <button
                          className="button"
                          type="button"
                          onClick={addNewRow}
                        >
                          {buttons.addNewRow}
                        </button>
                      </Tooltip>
                      <Tooltip content={tooltip.clearData}>
                        <button className="button" type="reset">
                          {buttons.clearData}
                        </button>
                      </Tooltip>
                    </div>
                  </fieldset>
                </form>
              </div>
              <div className="growth_calculator_section-second">
                <div
                  className="graph_container"
                  ref={ref => (this.chartAnchor = ref)}
                >
                  {loadingData && <Loading />}

                  {image && (
                    <figure className="growth_chart_container">
                      {<img src={image} alt="Growth Chart" />}
                      {/*showHeight && <img className="growth_chart_image graph-height" alt="Height Graph" src={`${calculatorEndpoint}/${dataSet}/webcharts.com/graph.jpg/Height?wct=&wcd=${image}&wcs=${selectedDate}&cachebust=${new Date()}`} />*/}
                      {/*!showHeight && <img className="growth_chart_image graph-weight" alt="Weight Graph" src={`${calculatorEndpoint}/${dataSet}/webcharts.com/graph.jpg/Weight?wct=&wcd=${image}&wcs=${selectedDate}&cachebust=${new Date()}`} />*/}
                      <figcaption className="growth_chart_legend">
                        <Toggle
                          isActive={showHeight}
                          handleToggle={handleSwitchGraph}
                          left={fields.measuredHeight}
                          right={fields.measuredWeight}
                        />

                        <Legend dataSet={dataSet} showHeight={showHeight} />
                        {targetHeight && showHeight && (
                          <TargetHeight
                            targetHeight={targetHeight}
                            isMetric={isMetric}
                            targetText={childsTargetHeight}
                          />
                        )}
                      </figcaption>
                    </figure>
                  )}
                </div>
                {image && (
                  <div className="buttons_container">
                    <Tooltip content={tooltip.downloadData}>
                      <button
                        id="calculator-download-pdf"
                        className="button"
                        type="button"
                        disabled={disabledPDF}
                        onClick={handleDownloadPDF}
                      >
                        {buttons.downloadPDF}
                      </button>
                    </Tooltip>
                    <Tooltip content={tooltip.saveData}>
                      <button
                        className="button"
                        type="button"
                        onClick={handleSaveData}
                      >
                        {buttons.saveData}
                      </button>
                    </Tooltip>
                  </div>
                )}
              </div>
            </div>
            {showError && <Notice severity="failure">{errorMessage}</Notice>}

            <div className="popup_container" data-active={belowHeight}>
              <dialog role="popup">
                <span className="button_container">
                  <button
                    tabIndex={showAbnormalWarning ? 0 : -1}
                    className="button button-icon popup_trigger-close"
                    onClick={clearAbnormalWarning}
                    type="button"
                    aria-label="Close this pop-up"
                  >
                    <Close />
                  </button>
                </span>
                {process.env.REACT_APP_LANG !== 'fr-fr' ? (
                  <div className="popup_content">
                    <p>{abnormalWarning.pTagFirst}</p>
                    <p>{abnormalWarning.pTagThird}</p>
                    <p>
                      <small>
                        <sup>1</sup>
                        {abnormalWarning.pTagFourth}
                      </small>
                    </p>
                  </div>
                ) : (
                  <div className="popup_content">
                    <p>{abnormalWarning.pTagFirst}</p>
                    <p>{abnormalWarning.pTagSecond}</p>
                  </div>
                )}
              </dialog>
            </div>

            {/* <div className="popup_container" data-active={aboveHeight}>
              <dialog role="popup">
                <span className="button_container">
                  <button
                    tabIndex={showAbnormalWarning ? 0 : -1}
                    className="button button-icon popup_trigger-close"
                    onClick={clearAbnormalWarning}
                    type="button"
                    aria-label="Close this pop-up"
                  >
                    <Close />
                  </button>
                </span>
                <div className="popup_content">
                  <p>{abnormalWarning.pTagFirst}</p>
                  <p>
                    <small>
                      <sup>1</sup>
                      {abnormalWarning.pTagFourth}
                    </small>
                  </p>
                </div>
              </dialog>
            </div> */}

            {iframeXML && (
              <iframe
                title="XML iFrame"
                className="growth_calculator_iframe"
                src={iframeXML}
                name="iframeXML"
              ></iframe>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default GrowthCalculator;
